import {
    ApiError,
    Body_modify_picture,
    User,
    UserContact,
    UserCreate,
    UserService,
} from '../types';
import {useMutation, useQuery, useQueryClient} from 'react-query';

import {USER_GET} from './keys';
import {UserIdentity} from '../types/models/UserIdentity';
import {UserPro} from '../types/models/UserPro';

export function useCreateUser() {
    return useMutation<User, ApiError, UserCreate>((params: UserCreate) =>
        UserService.createUser(params)
    );
}

export function useGetUser(enabled: boolean) {
    return useQuery(USER_GET, UserService.getUser, {
        enabled: enabled,
        refetchOnMount: true,
        staleTime: 1 * 60 * 1000, // 1 minute
    });
}

function invalidateUser(queryClient: any) {
    queryClient.invalidateQueries({queryKey: [USER_GET]});
}

export function useRemovePicture() {
    const queryClient = useQueryClient();
    return useMutation<boolean, ApiError, void>(() => UserService.removePicture(), {
        onSuccess: () => {
            invalidateUser(queryClient);
        },
    });
}

export function useModifyPicture() {
    const queryClient = useQueryClient();
    return useMutation<string, ApiError, Body_modify_picture>(
        (body: Body_modify_picture) => UserService.modifyPicture(body),
        {
            onSuccess: () => {
                invalidateUser(queryClient);
            },
        }
    );
}

export function useModifyIdentity() {
    const queryClient = useQueryClient();
    return useMutation<boolean, ApiError, UserIdentity>(
        (userIdentity: UserIdentity) => UserService.modifyIdentity(userIdentity),
        {
            onSuccess: () => {
                invalidateUser(queryClient);
            },
        }
    );
}

export function useModifyPro() {
    const queryClient = useQueryClient();
    return useMutation<boolean, ApiError, UserPro>(
        (userPro: UserPro) => UserService.modifyPro(userPro),
        {
            onSuccess: () => {
                invalidateUser(queryClient);
            },
        }
    );
}

export function useModifyContact() {
    const queryClient = useQueryClient();
    return useMutation<boolean, ApiError, UserIdentity>(
        (userContact: UserContact) => UserService.modifyContact(userContact),
        {
            onSuccess: () => {
                invalidateUser(queryClient);
            },
        }
    );
}

export function useModifyEmail() {
    const queryClient = useQueryClient();
    return useMutation<boolean, ApiError, string>(
        (email: string) => UserService.modifyEmail(email),
        {
            onSuccess: () => {
                invalidateUser(queryClient);
            },
        }
    );
}

export function useModifyLang() {
    const queryClient = useQueryClient();
    return useMutation<boolean, ApiError, string>(
        (lang: string) => UserService.modifyLang(lang),
        {
            onSuccess: () => {
                invalidateUser(queryClient);
            },
        }
    );
}

export function useDeleteUser() {
    const queryClient = useQueryClient();
    return useMutation<boolean, ApiError, void>(() => UserService.deleteUser(), {
        onSuccess: () => {
            invalidateUser(queryClient);
        },
    });
}
